import { render } from "./BrHeader.vue?vue&type=template&id=2c92d1f8&scoped=true"
import script from "./BrHeader.vue?vue&type=script&lang=js"
export * from "./BrHeader.vue?vue&type=script&lang=js"

import "./BrHeader.vue?vue&type=style&index=0&id=2c92d1f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c92d1f8"]])

export default __exports__